module.exports = __webpack_public_path__ + "img/paymentCreditCard.d6ea6b5a.svg";